import { render, staticRenderFns } from "./DistUserDetailsDialog.vue?vue&type=template&id=6c039c74&scoped=true"
import script from "./DistUserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./DistUserDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c039c74",
  null
  
)

export default component.exports